import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '../../store/hooks';
import { getProjectImage } from '../../Module/Project/Presentation/projectActions';

interface SafeHtmlViewerProps {
  html: string;
  className?: string;
  postData?: any;
}

const SafeHtmlViewer: React.FC<SafeHtmlViewerProps> = ({ html, className, postData }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  // 슬롯 플레이스홀더를 실제 이미지로 치환
  const processedHtml = React.useMemo(() => {
    if (!html || !postData) return html;
    
    let result = html;
    for (let i = 2; i <= 5; i++) {
      const placeholder = `[[IMG_SLOT_${i}]]`;
      const url = postData[`image${i}_url` as keyof typeof postData];
      
      if (result.includes(placeholder)) {
        if (url) {
          const replacement = `<figure data-embed="story-image"><img src="${url}" data-embed="image"></figure>`;
          result = result.replace(new RegExp(`\\[\\[IMG_SLOT_${i}\\]\\]`, 'g'), replacement);
        } else {
          result = result.replace(new RegExp(`\\[\\[IMG_SLOT_${i}\\]\\]`, 'g'), '');
        }
      }
    }
    return result;
  }, [html, postData]);

  useEffect(() => {
    if (!containerRef.current) return;

    const resolveImages = async () => {
      const images = containerRef.current?.querySelectorAll('img[data-embed="image"]');
      if (!images) return;

      images.forEach(async (img) => {
        const imageElement = img as HTMLImageElement;
        const src = imageElement.getAttribute('src');

        // URL 형태인지 확인 (http, https, data:, blob:)
        if (!src || src.startsWith('http') || src.startsWith('data:') || src.startsWith('blob:')) {
            return;
        }

        // src가 ID인 경우 (URL 형식이 아님)
        try {
          const result = await dispatch(getProjectImage({ image_id: src })).unwrap();
          if (result.image_url) {
            imageElement.src = result.image_url;
          }
        } catch (error) {
          console.error('Failed to resolve embedded image:', error);
        }
      });
    };

    resolveImages();
  }, [processedHtml, dispatch]);

  return (
    <Container
      ref={containerRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: processedHtml }}
    />
  );
};

const Container = styled.div`
  word-break: break-word;
  
  figure[data-embed="story-image"] {
    margin: 1em 0;
    width: 100%;
    
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
`;

export default SafeHtmlViewer;
